import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import WillGenerator from "@/pages/WillGenerator";
import DownloadByLink from "@/pages/DownloadByLink";
import AdminPulse from "@/pages/AdminPulse";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import Terms from "@/pages/legal/Terms";
import RefundPolicy from "@/pages/legal/RefundPolicy";
import Disclaimer from "@/pages/legal/Disclaimer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/will-generator" element={<WillGenerator />} />
            <Route path="/d/:willId" element={<DownloadByLink />} />
            <Route path="/admin/pulse" element={<AdminPulse />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
